
/**
 * @param {*} enumToConvert
 * @returns {Readonly<import("../../../../typings").Dictionary<string>>}
 */
export const enumToEnumNames = (enumToConvert) => Object.freeze(Object
    .entries(enumToConvert)
    .reduce((acc, [key, value]) => ({
        ...acc,
        [value]: key,
        [value.toString()]: key,
    }), {}));

export default enumToEnumNames;
